import createSimpleValidator from './createSimpleValidator';

const errorString = 'Vous devez entrer un numéro de téléphone mobile valide (10 chiffres, commençant par 06 ou 07).';
const checkIsMobilePhoneNumber = createSimpleValidator(
    (value) => value && /^0[67][0-9]{8}$/.test(value.replace(/ /g, '')),
    errorString,
);

export default checkIsMobilePhoneNumber;
